module.exports = __webpack_public_path__ + "img/MineStoryButton.29da24a5.png";